import useTranslate from 'modules/local/useTranslate'
import classNames from 'classnames'
import React, {useCallback, useContext} from 'react'
import {course_status_options} from 'views/AppLocals/Course'
import {NullAsDefault} from 'views/Shared'
import WorkspaceContext from "../../../WorkspaceContext";
import _ from "lodash";
import {FilterStatusBar} from "../../../../../components/Filters/FilterStatusBar";
import {CourseStates} from "../../WorkspaceCourse";


const labels = {
    status: 'status',
    status_text: 'course status',
    academic_year: 'academic year',
    academic_field: 'academic field',
};

// Nhãn RIÊNG cho ngữ cảnh chip filter này - KHÔNG dùng thẳng course_status_options.normal/closed.label
// ('active'/'close', key dùng chung ở 25+ chỗ khác + Select "Trạng thái" trong form Tạo/Sửa Khóa, đổi
// nghĩa ở đó sẽ ảnh hưởng lan). BE giờ kết hợp thêm điều kiện "còn hạn" (time_close chưa qua) khi lọc
// status=1 (xem CourseController::getCourses()) - "Hoạt động" đơn thuần dễ hiểu lầm là chỉ theo cờ
// bản ghi thô, đổi thành "Còn hiệu lực" để phân biệt rõ với nhóm chip "Trạng thái khóa học" ngay bên
// trên (Đang chiêu sinh/Đang chạy/Đã kết thúc - TÍNH THEO NGÀY, bạn báo 2 nhóm dễ gây hiểu lầm là 1).
const recordStatusFilterLabels = {
    [course_status_options.normal.value]: 'course record active status',
    [course_status_options.closed.value]: 'course record closed status',
}

// Chip toggle dùng chung cho 2 nhóm "lựa chọn giới hạn, xác định" bên dưới (trạng thái bản ghi +
// trạng thái khóa học) - trước đây trạng thái bản ghi dùng antd Radio.Group kiểu nút, trạng thái
// khóa học lại là 4 nút rời NẰM NGOÀI cả panel lọc (route riêng /?rel=enrolling-courses...) - gộp
// về 1 kiểu chip đồng nhất, cùng NẰM TRONG panel lọc (theo đúng yêu cầu).
const FilterChip = ({active, onClick, children}) => (
    <button
        type="button"
        onClick={onClick}
        style={{minHeight: 30}}
        className={classNames(
            'px-3 py-1 flex flex-center flex-shrink-0 gap-1 rounded-lg text-sm font-semibold transition-all cursor-pointer',
            active
                ? 'bg-secondary-500 text-white'
                : 'background shadow-sm hover:shadow-md text-slate-600 border border-color-50 hover:border-secondary-500 hover:text-secondary-500'
        )}>
        {children}
    </button>
)

export const CourseFilter = ({
                                 owner_id,
                                 owner_type,
                                 defaultValue = {
                                     status: 1,
                                 },
                                 academicYear,
                                 value: filter = {
                                     status: undefined,
                                     status_text: undefined,
                                     academic_year: undefined,
                                     academic_field: undefined
                                 },
                                 onChange: setValues = NullAsDefault,
                             }) => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext)

    const academicFieldOptions = [
        ..._.get(organization, 'workspace_settings.courses.groups.working_field_groups', [])
    ].filter(e => e != null && e !== '')
    const academicYearOptions = [
        ..._.get(organization, 'workspace_settings.courses.groups.working_year_groups', [])
    ].filter(e => e != null && e !== '')

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )

    const filteredParams = Object.entries(filter).filter(([key, value]) => {
        switch (key) {
            case "status":
            case "academic_year":
            case "academic_field":
            case "status_text":
            default:
                return value !== undefined && value !== null;
        }
    }).map(([key, value]) => {
        switch (key) {
            case "keyword":
                return {
                    key,
                    value,
                    displayValue: value,
                }
            case "academic_year":
                return {
                    key,
                    value,
                    displayValue: value,
                }
            case "academic_field":
                return {
                    key,
                    value,
                    displayValue: value,
                }
            case "status":
                const label = recordStatusFilterLabels[Number(value)]
                return {
                    key,
                    value,
                    displayValue: `${t('course record status')}: ${t(label)}`,
                }
            case "status_text":
                const label_text = _.find(CourseStates, item => item.value === value)?.label
                return {
                    key,
                    value,
                    displayValue: `${t('status')}: ${t(label_text)}`,
                }
            default:
                return {
                    key,
                    value,
                    displayValue: value,
                    label: labels[key] ||key,
                }
        }
    });

    return (
        <div className="flex flex-col gap-2 mt-2">
            <FilterStatusBar
                filteredParams={filteredParams}
                onClear={() => {
                    setValues(defaultValue)
                }}
                onRemove={(param) => {
                    handleChange(param, undefined)
                }}
            />
            {/* 2 nhóm chip "lựa chọn giới hạn, xác định" - trạng thái khóa học (trước đây là 3 route
                riêng /?rel=enrolling-courses... NẰM NGOÀI panel lọc, đã gộp về đây) + trạng thái bản
                ghi (trước đây antd Radio.Group kiểu nút) - cùng 1 kiểu chip, cùng nằm trong panel. */}
            <div className="flex flex-col gap-2">
                <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                    {t('course status')}
                </span>
                <div className="flex flex-wrap gap-2">
                    <FilterChip active={!filter.status_text} onClick={() => handleChange('status_text', undefined)}>
                        {t('all courses')}
                    </FilterChip>
                    {CourseStates.map(({label, value}) => (
                        <FilterChip
                            key={value}
                            active={filter.status_text === value}
                            onClick={() => handleChange('status_text', filter.status_text === value ? undefined : value)}>
                            {t(label)}
                        </FilterChip>
                    ))}
                </div>
            </div>
            {/* KHÔNG có chip "Tất cả" riêng ở đây (khác nhóm Trạng thái Khóa học phía trên, "Tất cả
                khóa học" vẫn giữ - đó là 1 lựa chọn THẬT/thường dùng, không chỉ để "bỏ chọn") - đây
                là filter, bấm lại đúng chip đang chọn để bỏ chọn là đã ra "tất cả" rồi, thêm 1 nút
                "Tất cả" riêng là thừa (bạn góp ý). */}
            <div className="flex flex-col gap-2">
                <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                    {t('course record status')}
                </span>
                <div className="flex flex-wrap gap-2">
                    {[course_status_options.normal, course_status_options.closed].map(({value}) => (
                        <FilterChip
                            key={value}
                            active={String(filter.status) === String(value)}
                            onClick={() => handleChange('status', String(filter.status) === String(value) ? undefined : String(value))}>
                            {t(recordStatusFilterLabels[value])}
                        </FilterChip>
                    ))}
                </div>
            </div>
            {/* Năm học - đổi từ dropdown sang chip (giống các nhóm trên, bạn góp ý thêm) - danh sách
                thực tế mỗi org chỉ vài năm (working_year_groups). */}
            {academicYearOptions.length > 0 && (
                <div className="flex flex-col gap-2">
                    <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                        {t('academic year')}
                    </span>
                    <div className="flex flex-wrap gap-2">
                        {academicYearOptions.map((year) => (
                            <FilterChip
                                key={year}
                                active={filter.academic_year === year}
                                onClick={() => {
                                    if (academicYear) return // khoá cùng lý do dropdown cũ từng disabled
                                    handleChange('academic_year', filter.academic_year === year ? undefined : year)
                                }}>
                                {year}
                            </FilterChip>
                        ))}
                    </div>
                </div>
            )}

            {/* Nhóm/Ngành học - đổi từ dropdown sang chip (giống 2 nhóm trên) - danh sách thực tế
                mỗi org chỉ vài mục (working_field_groups), bấm chọn thẳng nhanh hơn phải mở dropdown
                (bạn góp ý). */}
            {academicFieldOptions.length > 0 && (
                <div className="flex flex-col gap-2">
                    <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                        {t('academic field')}
                    </span>
                    <div className="flex flex-wrap gap-2">
                        {academicFieldOptions.map((field) => (
                            <FilterChip
                                key={field}
                                active={filter.academic_field === field}
                                onClick={() => {
                                    if (academicYear) return // khoá cùng lý do SelectWidget cũ từng disabled
                                    handleChange('academic_field', filter.academic_field === field ? undefined : field)
                                }}>
                                {field}
                            </FilterChip>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default CourseFilter
